import { useParams } from "react-router-dom";
import PageNotFound from "../../pages/PageNotFound";
import { Article } from "../../ui/atoms/Article";
import { useState } from "react";
import useMobile from "../../hooks/useMobile";
import { Container } from "../atoms/Container";
import { Brand } from "../header/Brand";
import { ControlsVideos } from "../../features/campaign/components/organism/ControlsVideos";
import { AnimatePresence, motion } from "framer-motion";
import { LazyVideo } from "../../features/projects/component/atoms/LazyVideo";
import { ContentCustom } from "./ContentCustom";
import { BackButton } from "../button/BackButton";
import { PrevAndNextNavigation } from "./PrevAndNextNavigation";
import {useFetchAllNews}  from "../../features/actus/hooks/useFetchAllNews";


export const MediaShow = ({ fetchHook, type }) => {

    const [isPlayed, setIsPlayed] = useState(true);
    const [isMuted, setIsMuted] = useState(false);

    const isMobile = useMobile();
    const { slug } = useParams();

    const { data, error } = fetchHook(slug);

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/posts`;

    if (error) return <PageNotFound />;
    
    return (
        <Article className="h-screen">
        <Container className="lg:w-10/12 w-full h-screen flex items-stretch justify-center relative">
            
            {/* Top Controls */}
            <div className="z-10 lg:w-full bgred-200 w-10/12 absolute lg:left-0 h-24 flex justify-start items-stretch">
                <div className="w-full grow flex items-center justify-between text-orange-600">
                    <Brand title />
                    {isMobile && data?.video && (
                        <ControlsVideos
                            isPlayed={isPlayed}
                            setIsPlayed={setIsPlayed}
                            isMuted={isMuted}
                            setIsMuted={setIsMuted}
                        />
                    )}
                    <BackButton path="actus"/>
                </div>
            </div>

            <AnimatePresence initial={false} mode="wait">
                <motion.div
                    className="w-[600px] h-full relative"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ opacity: { type: "spring", stiffness: 300, damping: 40 } }}
                >
                    {/* Desktop Controls */}
                    {(type === "actus" && !isMobile && data?.video) && (
                    <div className="z-10 lg:w-10/12 absolute lg:left-1/2 transform lg:-translate-x-1/2 h-24 flex justify-end items-stretch">
                        <ControlsVideos
                            isPlayed={isPlayed}
                            setIsPlayed={setIsPlayed}
                            isMuted={isMuted}
                            setIsMuted={setIsMuted}
                        />
                    </div>
                    )}

                    <ContentCustom data={data} type={type} />

                    {/* Image fallback */}
                    {( data?.picture || data?.mainImage ) && (
                    <div className="w-full h-screen">
                        <figure className="w-full h-screen">
                        <img
                            className="w-full h-full object-cover"
                            src={type === "actus" ? `${process.env.REACT_APP_API_URL}/uploads/${data.picture}`  : `${process.env.REACT_APP_URL_CLOUDFARE}/images/${data.mainImage}.webp` }
                            alt={data.title}
                        />
                        </figure>
                    </div>
                    )}

                    {/* Video player */}
                    {data?.video && (
                    <LazyVideo
                        videoSrc={`${process.env.REACT_APP_URL_CLOUDFARE}video/${data.video}`}
                        isMuted={isMuted}
                        isPlayed={isPlayed}
                        setIsPlayed={setIsPlayed}
                    />
                    )}

                    {/* Overlay */}
                    <div className="z-10 absolute w-full left-0 bottom-0 h-52 bg-gradient-to-t from-10% from-black to-transparent" />
                </motion.div>
            </AnimatePresence>

            <PrevAndNextNavigation 
                fetchHook={useFetchAllNews} 
                apiUrl={apiUrl} 
                indexUrl="actus"
            />
        </Container>
        </Article>
    );
};